'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:ui:loadingStart');
}

var _invoke = require('../invoke');

/**
 * 开启加载动画
 *
 * 在关闭前多次调用存在 bug，需要业务方自己把握开启／关闭的配对关系
 *
 * 支持版本
 * + iHotel/5.8+
 *
 * @memberof ui
 * @static
 * @name loadingStart
 * @return {Undefined}
 * @example
 *  hbnb.ui.loadingStart();
 */
module.exports = function() {
    if (process.env.NODE_ENV !== 'production') {
        debug('start');
    }

    _invoke('ui', 'loading_start');
};



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/ui/loading-start.js
// module id = 651
// module chunks = 0